import React from "react";
import Meta from "./../components/Meta";
import HeroSection2 from "./../components/HeroSection2";
import TeamBiosSection from "./../components/TeamBiosSection";

function AboutPage(props) {
  return (
    <>
      <Meta title="About" description="Learn about our company and team" />
      <br></br>
      <br></br>
      <HeroSection2
        color="secondary"
        size="large"
        backgroundImage="/winsted.svg"
        backgroundImageOpacity={0.2}
        title="We &hearts; decentralized digital property rights"
        subtitle="The PDS team has been building data licensing systems together since 2016. We are a group of technology professionals with a wealth of expertise and a passion for building the future of intellectual property."
      />
      <TeamBiosSection
        color="white"
        size="medium"
        backgroundImage="/halftone-1696560535.svg"
        backgroundImageOpacity={1}
        title="Leadership"
        subtitle=""
      />
    </>
  );
}

export default AboutPage;
